module.exports = __webpack_public_path__ + "static/media/about4.b5d36c60.jpg";